import React, {Component} from 'react';
import propTypes from 'prop-types';
import {Redirect, Route} from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import Data from "./Data";

class ModalAddMaster extends Component {

    constructor(props){
        super(props);
        this.state = {
            fields : {
                name : "",
                userid : "",
                phone : "",
                bio : "",
                file : ""
            },
            errors : {

            }
        }

    }

    componentDidMount() {

    }

    handleChange(event){
        let fields = this.state.fields;
        let target = event.target;
        let value = target.value;
        fields[target.name] = value;
        this.setState({fields});
    }

    handleSubmit(event){

        event.preventDefault();

        this.handleValidation((valid)=>{
            if (valid){
                this.handleRequest();
            }
        })

    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = this.state.errors;
        let formIsValid = true;

        if (fields.name === ""){
            formIsValid = false;
            errors['name'] = 'لطفا نام استاد را وارد کنید!';
        }else {
            errors['name'] = null;
        }
        if (fields.userid === ""){
            formIsValid = false;
            errors['userid'] = 'لطفا یک نام کاربری مشخص کنید!';
        }else {
            errors['userid'] = null;
        }

        this.setState({errors}, ()=>{
            return callback(formIsValid);
        });
    }

    selectFile(text , btnid, imgid){

        $('#'+btnid).addClass('btn-outline-warning');
        $('#'+btnid).removeClass('btn-outline-danger');
        $('#'+btnid+' p').text("در حال بارگذاری ...");
        let filesize = ((text.target.files[0].size/1024)/1024).toFixed(4);

        if (filesize >= 5){
            this.props.toast("فایل بیشتر از 5 مگابایت حجم دارد",3000,"bg-warning",()=> {
                $('#liveToast').toast('show');
            });

            $('#'+btnid).addClass('btn-outline-primary');
            $('#'+btnid).removeClass('btn-outline-warning');
            $('#'+btnid+' p').text("تغییر عکس");
        }else {
            let filename = this.generate_random_string(6,'qwertyuiopasdfghjklzxcvbnm0123456789')+'_'+text.currentTarget.files[0].name;
            const url = Data.mainserver+'uploadFile.php';
            const formData = new FormData();
            formData.append('file',text.target.files[0],filename);

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            axios.post(url, formData,config)
                .then(response => {
                    console.log(response.data);
                    if (response.data.hasOwnProperty('filename')){
                        const {fields} = this.state;
                        fields['file'] = response.data.filename;
                        this.setState({fields});
                        $('#'+imgid)[0].src = Data.mainserver+"images/"+response.data.filename;
                        $('#'+btnid).addClass('btn-outline-success');
                        $('#'+btnid).removeClass('btn-outline-warning');
                        $('#'+btnid+' span').removeClass('invisible');
                        $('#'+btnid+' p').text("عکس پیوست شد");
                    }
                })
                .catch(error => {
                    $('#'+btnid).addClass('btn-outline-danger');
                    $('#'+btnid).removeClass('btn-outline-warning')
                    $('#'+btnid+' p').text("عکس پیوست نشد !!!");
                    console.log(error);
                });
        }

    }
    deleteFile(e , imgid){

        $('#'+imgid)[0].src = Data.server+"icons/user.png";

        const {fields} = this.state;
        fields['file'] = "";
        this.setState({fields});

    }

    generate_random_string(length,text){
        var result           = '';
        var charactersLength = text.length;
        for ( var i = 0; i < length; i++ ) {
            result += text.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    handleRequest(){
        
        $('#'+this.props.id).modal('hide');
        $('#waitspinner').modal('show');

        const {name,userid,phone,bio,file} = this.state.fields;

        let data = new FormData();
        data.append('name',name);
        data.append('userid',userid);
        data.append('phone',phone);
        data.append('bio',bio);
        data.append('file',file);


        axios.post(Data.server+'addMaster.php',data)
            .then(response=>{

                console.log(response.data);
                $('#waitspinner').modal('hide');
                $('div.modal-backdrop.fade.show').remove();

                if (response.data === "ok") {

                    this.props.toast("استاد با موفقیت ثبت شد",3000,"bg-success",()=> {
                        $('#liveToast').toast('show');
                        window.location.reload();

                    });

                }
                if (response.data === "duplicate userid") {

                    this.props.toast("نام کاربری تکراری است",3000,"bg-warning",()=> {
                        $('#liveToast').toast('show');
                    });

                }
                
                if (response.data.includes("error insert")){
                    this.props.toast("خطای داخلی رخ داد",3000,"bg-danger",()=> {
                        $('#liveToast').toast('show');
                    });
                }

            })
            .catch(error=>{
                $('#progressTop').addClass('invisible');
                $('#r_fab').addClass('animate__animated animate__zoomIn');
                console.log(error);
            });
    }

    render() {
        const {id} = this.props;

        const {name , userid , phone , bio} = this.state.fields;
        const {errors} = this.state;

        let uploadid = "upload-fileadd";
        let btnid = "btn_fileadd";
        let imgid = "masterpictureadd";

        return (
            <div className="modal fade" id={id} tabIndex="-1" aria-labelledby={id+"Label"}
                                         aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id={id+"Label"}>{"افزودن استاد"}</h6>
                            <button type="button" className="close text-left ml-0" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body text-center">
                            <img id={imgid} className="circle-icon" style={{zIndex:'999'}} width="128px" height="128px"
                                 src={Data.mainserver+"icons/user.png"}/>

                            <input
                                className="novisible"
                                id={uploadid}
                                multiple
                                type="file"
                                accept="image/jpeg, image/png"
                                onChange={(e) => this.selectFile(e,btnid,imgid)}
                            />

                            <button onClick={(e) => $('#'+uploadid).trigger('click')} type="button" id={btnid} className="btn btn-outline-primary mt-3 w-100 d-flex align-items-center justify-content-center">
                                <span className="oi oi-check invisible"/>
                                <p className="px-4 py-1 my-0 text-dark">افزودن عکس</p>
                                <span className="oi oi-file"/>
                            </button>
                            <small className="my-2">فقط فایل های کمتر از 5 مگابایت بارگذاری میشود</small>

                            <button onClick={(e) => this.deleteFile(e,imgid)} type="button" id="delbtn" className="btn btn-outline-danger mt-3 w-100 d-flex align-items-center justify-content-center">
                                <span className="oi oi-check invisible"/>
                                <p className="px-4 py-1 my-0 text-dark">حذف عکس</p>
                                <span className="oi oi-file"/>
                            </button>

                            <strong>پر کردن فیلدهای ستاره دار اجباری است</strong>

                            <form className="login-form mx-auto">
                                <div className="form-group text-right">
                                    <label className='important-input'>نام و نام خانوادگی</label>
                                    <input
                                        type="name"
                                        className={["form-control", errors['name'] ? 'is-invalid':'is-valid'].join(' ')}
                                        name="name"
                                        value={name}
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="لطفا نام و نام خانوادگی استاد را وارد کنید"/>
                                    <span className="invalid-feedback rtl" style={{display : errors['name'] ? 'block':'none'}}>{errors['name']}</span>
                                </div>
                                <div className="form-group text-right">
                                    <label className='important-input'>{"نام کاربری (انگلیسی)"}</label>
                                    <input
                                        type="userid"
                                        className={["form-control", errors['userid'] ? 'is-invalid':'is-valid'].join(' ')}
                                        name="userid"
                                        value={userid}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.replace(/[^A-Za-z0-9]+$/ig, '')
                                        }}
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="لطفا یک نام کاربری مشخص کنید . مثال : alireza-sajadi"/>
                                    <span className="invalid-feedback rtl" style={{display : errors['userid'] ? 'block':'none'}}>{errors['userid']}</span>
                                </div>
                                <div className="form-group text-right">
                                    <label>{"شماره موبایل"}</label>
                                    <input
                                        type="phone"
                                        className={["form-control", errors['phone'] ? 'is-invalid':'is-valid'].join(' ')}
                                        name="phone"
                                        value={phone}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.toString().slice(0, 11)
                                            e.target.value = e.target.value.replace(/\D/g, "")
                                        }}
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="شماره موبایل استاد را وارد کنید"/>
                                    <span className="invalid-feedback rtl" style={{display : errors['phone'] ? 'block':'none'}}>{errors['phone']}</span>
                                </div>
                                <div className="form-group text-right">
                                    <label>بیوگرافی</label>
                                    <textarea
                                        rows="4"
                                        className={["form-control", errors['bio'] ? 'is-invalid':'is-valid'].join(' ')}
                                        name="bio"
                                        value={bio}
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="لطفا بیوگرافی استاد را وارد کنید"/>
                                    <span className="invalid-feedback rtl" style={{display : errors['bio'] ? 'block':'none'}}>{errors['bio']}</span>

                                </div>

                            </form>
                        </div>
                        <div className="modal-footer">
                            <div className="btn-group">
                                <button type="submit" className="btn btn-info" onClick={this.handleSubmit.bind(this)}>تایید</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">لغو</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default ModalAddMaster;
